import { LanguageMessage } from './language-message';

/**
 * è±æè¯­è¨æ¶æ¯
 */
class LanguageMessageForZh implements LanguageMessage {
  public yes = 'æ¯';
  public no = 'å¦';
  public unsaveNotifyTitle = 'å­å¨æªä¿å­è®°å½ãæ¯å¦è¦ä¿å­ï¼';
  public clientNotifyTitle = 'åç«¯å¼å¸¸æç¤º';
  public serverNotifyTitle = 'æå¡å¨ç«¯å¼å¸¸æç¤º';
  public cancelApproveSuccess = 'åæ¶æäº¤æåï¼';
  public cancelApproveFailed = 'åæ¶æäº¤å¤±è´¥ï¼';
  public unallowEmptyProcessInstanceName = 'æµç¨å®ä¾åç§°ä¸è½ä¸ºç©º';
  public unallowEmptyBizBillId = 'è¯·éæ©ä¸æ¡æ°æ®';
  public bizDefKeyRequired = 'å¥å£åæ®ä¸è½ä¸ºç©º';
  public unallowEmptyChildBizBillId = 'ä»è¡¨ä¸å¡åæ®ç¼å·ä¸è½ä¸ºç©ºï¼';
  public procInsIdRequired = 'æµç¨å®ä¾Idä¸è½ä¸ºç©ºï¼';
  public addChildFailed = 'æ°å¢å­çº§å¤±è´¥';
  public addSiblingFailed = 'æ°å¢åçº§å¤±è´¥';
  public addSubChildFailed = 'æ°å¢ä»è¡¨å­çº§å¤±è´¥';
  public addSubSiblingFailed = 'æ°å¢ä»è¡¨åçº§å¤±è´¥';
  public deleteFailed = 'å é¤å¤±è´¥';
  public multiSaveFailed = 'æ¹éä¿å­å¤±è´¥';
  public appendFailed = 'è¿½å å¤±è´¥';
  public queryFailed = 'æ¥è¯¢å¤±è´¥';
  public cancelFailed = 'åæ¶å¤±è´¥';
  public updateFailed = 'æ´æ°å¤±è´¥';
  public addFailed = 'æ°å¢å¤±è´¥';
  public loadFailed = 'å è½½å¤±è´¥';
  public saveSuccess = 'ä¿å­æåï¼';
  public saveFailed = 'ä¿å­å¤±è´¥ï¼';
  public deleteSuccess = 'å é¤æåï¼';
  public deleteFaild = 'å é¤å¤±è´¥ï¼';
  public confirmDeletion = 'ç¡®è®¤å é¤ï¼';
  public submitSuccess = 'æäº¤å®¡æ¹æåï¼';
  public submitFaild = 'æäº¤å®¡æ¹å¤±è´¥ï¼';
  public notifyTitle = 'ç³»ç»æç¤º';
  public httpError = 'HTTPè¯·æ±éè¯¯ï¼è¯·æ£æ¥Serverç«¯éè¯¯ï¼';
  public gridDataNotSave = 'å½åé¡µæ°æ®æªä¿å­ï¼ç¿»é¡µå°å¯¼è´æ°æ®ä¸¢å¤±ï¼æ¯å¦ç»§ç»­ç¿»é¡µï¼';
  public exitWithoutSave = 'å­å¨æªä¿å­çæ°æ®ï¼æ¯å¦ç»§ç»­å³é­ï¼';
  public notSupportMenuType = 'å³é­çæ¢ä¸æ¯èåä¹ä¸æ¯åºç¨ã';
  public cancelWithoutSave = 'å­å¨æªä¿å­çåæ´ï¼ç¡®è®¤åæ¶ï¼';
  public plsSelectDeleteData = 'è¯·éæ©è¦å é¤çæ°æ®ï¼';
  public errorHierarchyKey = 'éè¯¯çåçº§ç ';
  public plsSelectParentNode = 'è¯·éæ©ç¶èç¹';
  public deleteChildFirst = 'è¯·åå é¤å­èç¹';
  public incorrectHierarchyConfig = 'åçº§ç éç½®ä¿¡æ¯éè¯¯';
  public operationFailed = 'æä½æ§è¡å¤±è´¥ã';
  public plsSelectEditData = 'è¯·éæ©è¦ç¼è¾çæ°æ®ï¼';
  public plsSelectViewData = 'è¯·éæ©è¦æ¥ççæ°æ®ï¼';
  public plsUploadFirst = 'è¯·åä¸ä¼ éä»¶ï¼';
  public defaultDialogTitle = 'å¼¹çª';
  public changeToFirst = 'å·²å°è¾¾ç¬¬ä¸æ¡æ°æ®';
  public changeToLast = 'å·²å°è¾¾æåä¸æ¡æ°æ®';
  public noProcessInstanceId = 'è¯·æå®æµç¨å®ä¾æ è¯ã';
  public noDataExist = 'è¦ç¼è¾çæ°æ®ä¸å­å¨ï¼æ æ³è¿å¥ç¼è¾ç¶æï¼';
  public noAttachment = 'æ²¡æå¯ä»¥é¢è§çéä»¶ã';
  public confirm = 'ç¡®å®';
  public cancel = 'åæ¶';
  public plsSelectCopyData = 'è¯·éæ©è¦å¤å¶çæ°æ®ï¼';
  public copyFieldsRequired = 'è¦å¤å¶çå­æ®µä¸è½ä¸ºç©ºï¼';
  public pathIsRequired = 'è¯·æ±è·¯å¾ä¸è½ä¸ºç©ºï¼';
  public propsIsEmpty = 'æ²¡æå¯ä»¥ç¼è¾çç©æç¹å¾ï¼';
  public historyAttachment = 'åå²çæ¬éä»¶ç¦æ­¢å é¤ï¼';
  public plsSelectDownloadAtt = 'è¯·éæ©è¦ä¸è½½çéä»¶!';
  public noDownloadAtt = 'æ¾ä¸å°è¦ä¸è½½çéä»¶!'
  public plsCheckBatchEditRows = 'è¯·å¾éè¦æ¹éç¼è¾çè¡ï¼';
  public plsSelectDetailFormData = 'è¯·åéæ©ä¸æ¡ä»è¡¨æ°æ®ï¼';
  public dataAndStateChanged = 'ç¡®å®è¦å è½½æ°æ®å¹¶åæ¢å°$1ç¶æï¼';
  public dataChanged = 'ç¡®å®è¦å è½½æ°æ®å¹¶æ¾å¼å½åä¿®æ¹ï¼';
  public stateChanged = 'ç¡®å®è¦åæ¢å°$1ç¶æï¼';
  public defaultStateName = 'åå§';
  public copy = 'å¤å¶è¯¦ç»ä¿¡æ¯';
  public copySuccess = 'å¤å¶æå';
  public copyFailed = 'å¤å¶å¤±è´¥';
  public roger = 'ç¥éäº';
  public appOrFuncIdRequired = 'æªéç½®èåæåºç¨åæ°ï¼è¯·å¨è®¾è®¡å¨ä¸­éç½®ã';
  public tableCanNotEmpty = 'ä¸è½ä¸ºç©ºã';
  public plsSelectRemoveAtt = 'è¯·éæ©è¦å é¤çéä»¶!';
  public plsSelectUpdateRow = 'è¯·éæ©è¦æ´æ°éä»¶çè¡ï¼';
  public hasChangeCheckFaild ='å¨æ£æ¥é¡µé¢æ¯å¦å­å¨æªä¿å­çåæ´æ¶åçéè¯¯ï¼è¯·ç¡®ä¿æ°æ®å·²ç»ä¿å­ãæ¯å¦ç»§ç»­å³é­ï¼';
  public noParentData = 'è¯·éæ©ä¸çº§æ°æ®ï¼';
}

export { LanguageMessageForZh };
